<div class="rules-grid-container" #gridContainer>
  <table mat-table
         [dataSource]="userGuideRules"
         [trackBy]="trackByRule"
         class="rules-grid">

    <ng-container matColumnDef="rule">
      <th mat-header-cell *matHeaderCellDef class="col-rule">Rule ID</th>
      <td mat-cell *matCellDef="let row" class="col-rule">{{ row.rule }}</td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef>Description</th>
      <td mat-cell *matCellDef="let row">{{ row.description }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row
        #ruleRow
        *matRowDef="let row; columns: displayedColumns;"
        [class.selected-row]="row === currentRule"></tr>
  </table>

  <div *ngIf="!userGuideRules?.length" class="rules-grid-empty">
    No validation rules to display.
  </div>
</div>
